let ConfigSite = {};

//Production
if (process.env.NODE_ENV === 'production') {
  ConfigSite = {
    SERVICE_URL: 'https://services.gabitosoft.com:7002/api',
    APP_URL: 'https://srl.mafume.com/erp',
    TIME_DISPLAY_MESSAGES: 5
  };
}

//Development
if (process.env.NODE_ENV !== 'production') {
  ConfigSite = {
    SERVICE_URL: 'http://localhost:9000/api',
    APP_URL: 'http://localhost:3000',
    TIME_DISPLAY_MESSAGES: 5
  };
}

export default ConfigSite;



// WEBPACK FOOTER //
// ./src/configSite.js